const EDGE_DEV_BASE = 'http://localhost:3010';
const EDGE_PROD_PROXY_BASE = '/edge';

const utils = {
    getEdgeBasePath() {
        const productionEdge = (typeof localStorage === 'undefined') ? process.env.EDGE_URL : EDGE_PROD_PROXY_BASE;
        const basePath = (process.env.NODE_ENV === 'production') ? productionEdge : EDGE_DEV_BASE;
        return basePath;
    },
    /** Client health checks: always via /edge reverse proxy (nginx in prod, catalog dev proxy locally). */
    getEdgeHealthUrl() {
        if (typeof window === 'undefined') {
            return null;
        }

        return `${EDGE_PROD_PROXY_BASE}/is_alive`;
    },
    /** JWT header for edge `/api/v1/admin/*` routes (set by NewAdminPage after login). */
    getAdminAuthHeaders() {
        if (typeof window === "undefined" || !window.localStorage) {
            return {};
        }
        const token = window.localStorage.getItem("admin_token");
        return token ? { "x-auth-token": token } : {};
    },
};

export default utils;